import { useDispatch } from "react-redux";
import { FilterOption } from "../../../../models";
import { RequestFilterModelType } from "../../../../services";
import {
  updateFilters,
  updateModelTypeFilters,
} from "../../../../store/reducer/_searchReducer";
import { PDLAccordion, PDLCheckbox, PDLTypography } from "../../dna";
import FiltrosItem from "../_filtrosItem";

export interface FiltroOpcoesProps {
  id?: string | null;
  options: FilterOption[];
  isModelTypeFilterItem?: boolean;
  modelType?: RequestFilterModelType | undefined;
}

const FiltroOpcoes = ({
  id: parentId = null,
  options = [],
  isModelTypeFilterItem,
  modelType,
}: FiltroOpcoesProps) => {
  const dispatch = useDispatch();

  const toggleOption = (option: FilterOption) => {
    if (isModelTypeFilterItem && !!modelType) {
      console.log({ option, modelType });
      dispatch(updateModelTypeFilters({ option, modelType }));
    } else {
      console.log({ option });
      dispatch(updateFilters({ option }));
    }
  };

  const Label = ({ value }: { value: string }) => (
    <PDLTypography size="sm">{value}</PDLTypography>
  );

  const renderOpcao = (option: FilterOption, index: number) => {
    const { type, label, checked, id } = option;

    if (type === "group" && "options" in option) {
      const allChecked = option.options.every((o) => o.checked);
      const noneChecked = option.options.every((o) => !o.checked);
      const indeterminate = !allChecked && !noneChecked;

      const Title = () => (
        <PDLCheckbox
          label={<Label value={label} />}
          checked={allChecked}
          indeterminate={indeterminate}
          handleChange={() => toggleOption(option)}
        />
      );

      return (
        <PDLAccordion key={`filtros-item-group-accordion-${id}-${index}`} flush>
          <FiltrosItem
            key={`filtros-item-group-${id}-${index}`}
            title={<Title />}
            options={option.options}
            id={id}
            index={index}
            padding={true}
            isModelTypeFilterItem={isModelTypeFilterItem || false}
          />
        </PDLAccordion>
      );
    }

    return (
      <div
        key={`filtros-item-option-${id}-${index}`}
        className="d-flex flex-row align-items-center justify-content-between ps-4 py-2"
      >
        <PDLCheckbox
          label={<Label value={label} />}
          checked={!!checked}
          handleChange={() => toggleOption(option)}
        />
      </div>
    );
  };

  return <div>{options.map(renderOpcao)}</div>;
};

export default FiltroOpcoes;
